// Countries as the server stores them: ISO 3166-1 alpha-2 codes in
// suppliers.country. Same list as server/services/businessIdentity.js — keep
// the two together. Names come from the browser (Intl.DisplayNames).

export const COUNTRY_CODES = (
  'AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ '
  + 'CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK '
  + 'FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT '
  + 'JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML '
  + 'MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM '
  + 'PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD '
  + 'TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
).split(' ');

/** Where most Zilch customers are, offered first in a country picker. */
export const COMMON_COUNTRIES = ['AU', 'NZ', 'GB', 'US'];

let displayNames = null;
try {
  displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
} catch {
  displayNames = null;
}

export function countryName(code) {
  if (!code) return '';
  try {
    return displayNames?.of(code) || code;
  } catch {
    return code;
  }
}

export const COUNTRIES = COUNTRY_CODES
  .map((code) => ({ code, name: countryName(code) }))
  .sort((a, b) => a.name.localeCompare(b.name));

const comparable = (value) => String(value || '').toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ').trim();

const ALIASES = {
  uk: 'GB', 'great britain': 'GB', britain: 'GB', england: 'GB', scotland: 'GB', wales: 'GB', 'northern ireland': 'GB',
  usa: 'US', 'united states of america': 'US', america: 'US',
  aus: 'AU', aotearoa: 'NZ',
};

/** The code for whatever an older record holds ("AU", "Australia", "UK"), or ''. */
export function countryCodeOf(value) {
  const text = comparable(value);
  if (!text) return '';
  if (ALIASES[text]) return ALIASES[text];
  const upper = text.toUpperCase();
  if (/^[A-Z]{2}$/.test(upper) && COUNTRY_CODES.includes(upper)) return upper;
  return COUNTRIES.find((c) => comparable(c.name) === text)?.code || '';
}
